(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[6957],{

/***/ 36727:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "t": function() { return /* binding */ LegacyInput; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(91987);
/* harmony import */ var _emotion_styled__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(21483);
/* harmony import */ var _teko_ui__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(49781);




var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const MAX_PRICE = 1e11;
const StyledInput = _emotion_styled__WEBPACK_IMPORTED_MODULE_1__["default"].input(({ error, allowClear, prefixIcon, disabled, theme: { colors } }) => `
    //Remove input shadow on IOS Safari
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;

    box-sizing: border-box;
    margin: 0;
    font-variant: tabular-nums;
    list-style: none;
    font-feature-settings: 'tnum';
    position: relative;
    display: inline-block;
    width: 100%;
    min-width: 0;
    padding: 4px 10px;
    color: ${colors.text};
    font-size: 14px;
    line-height: 1.5715;
    background-image: none;
    border: 1px solid
      ${!!error ? colors.error : colors.border} !important;
    border-radius: 4px;
    transition: all 0.3s;
    ${allowClear ? "padding-right: 32px" : ""};
    ${prefixIcon ? "padding-left: 36px" : ""};
    ${!disabled ? "background-color: #fff" : ""};

    &:hover {
      border-color: ${!!error ? colors.error : "#40a9ff"};
    }

    &:focus {
      border-color: ${!!error ? colors.error : "#40a9ff"};
      border-right-width: 1px !important;
      outline: 0;
      box-shadow: 0 0 0 2px
        ${!!error ? "rgba(255,77,79,.2)" : "rgba(24, 144, 255, 0.2)"};
    }
  `);
const InputContainer = _emotion_styled__WEBPACK_IMPORTED_MODULE_1__["default"].div`
  position: relative;
`;
const ClearIcon = (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_1__["default"])(_teko_ui__WEBPACK_IMPORTED_MODULE_2__/* .SvgIcon */ .l)`
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  right: 0.75rem;
  width: 1.25rem;
  height: 1.25rem;
  background-color: #bbb;
`;
const Label = _emotion_styled__WEBPACK_IMPORTED_MODULE_1__["default"].label(({ required, theme }) => `
    margin-bottom: 0.4rem;
    font-weight: 500;
    &::before {
      content: '*';
      display: ${required ? "inline-block" : "none"};
      margin-right: 4px;
      color: ${theme == null ? void 0 : theme.colors.error};
      font-size: 14px;
      width: max-content;
    }
  `);
const Error2 = _emotion_styled__WEBPACK_IMPORTED_MODULE_1__["default"].div(({ theme }) => `
    padding-top: 0;
    color: ${theme == null ? void 0 : theme.colors.error500};
    font-size: 0.75rem;
    line-height: 1rem;
    transition: color 0.4s cubic-bezier(0.215, 0.61, 0.355, 1);
    margin-top: 0.5rem;
  `);
const PrefixIcon = (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_1__["default"])(_teko_ui__WEBPACK_IMPORTED_MODULE_2__/* .SvgIcon */ .l)`
  position: absolute;
  top: 5px;
  left: 10px;
  cursor: pointer;
  z-index: 1;
`;
const Currency = _emotion_styled__WEBPACK_IMPORTED_MODULE_1__["default"].div`
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  right: 0.75rem;
`;
const Wrapper = _emotion_styled__WEBPACK_IMPORTED_MODULE_1__["default"].div`
  margin-bottom: 1rem;
`;
function resolveOnChange(target, e, onChange) {
  if (onChange) {
    let event = e;
    if (e.type === "click") {
      event = Object.create(e);
      event.target = target;
      event.currentTarget = target;
      const originalInputValue = target.value;
      target.value = "";
      onChange(event);
      target.value = originalInputValue;
      return;
    }
    onChange(event);
  }
}
const formatCurrency = (money) => {
  return money ? money.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1.") : `${money}`;
};
const LegacyInput = (_a) => {
  var _b = _a, {
    value,
    allowClear = true,
    label,
    required,
    error,
    name,
    prefixIcon,
    isFocused,
    allowFocus,
    inputType,
    currency,
    className,
    onChange
  } = _b, restProps = __objRest(_b, [
    "value",
    "allowClear",
    "label",
    "required",
    "error",
    "name",
    "prefixIcon",
    "isFocused",
    "allowFocus",
    "inputType",
    "currency",
    "className",
    "onChange"
  ]);
  const [internalValue, setInternalValue] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)("");
  const textInputRef = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(null);
  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(() => {
    if (inputType === "price") {
      setInternalValue(formatCurrency(String(value)));
    } else {
      setInternalValue(value);
    }
  }, [value]);
  const handlePriceInput = (value2) => {
    value2 = value2.replace(/\./g, "");
    if (/^\d*$/.test(value2))
      return value2;
    return null;
  };
  const handleChange = (e) => {
    let value2 = e.target.value;
    if (inputType === "price") {
      value2 = handlePriceInput(value2);
      if (value2 !== null && textInputRef.current !== null) {
        if (Number(value2) > MAX_PRICE) {
          value2 = String(MAX_PRICE);
        }
        e.target.value = value2;
        resolveOnChange(textInputRef.current, e, onChange);
      }
    } else {
      if (textInputRef.current !== null) {
        setInternalValue(value2);
        resolveOnChange(textInputRef.current, e, onChange);
      }
    }
  };
  const handleClear = (e) => {
    if (textInputRef.current) {
      setInternalValue("");
      textInputRef.current.focus();
      resolveOnChange(textInputRef.current, e, onChange);
    }
  };
  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(() => {
    if (textInputRef.current && isFocused) {
      textInputRef.current.focus();
    }
  }, [isFocused]);
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Wrapper, {
    className
  }, label && /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Label, {
    className: "input__label",
    required
  }, label), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(InputContainer, null, prefixIcon && /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(PrefixIcon, {
    name: prefixIcon,
    size: 22
  }), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(StyledInput, __spreadProps(__spreadValues({
    name,
    label,
    value: internalValue,
    allowClear,
    onChange: handleChange,
    ref: textInputRef,
    error,
    prefixIcon,
    required
  }, restProps), {
    className: "input__input"
  })), allowClear && !!internalValue && /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(ClearIcon, {
    name: "circle-close",
    onClick: handleClear
  }), !!currency && /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Currency, null, currency)), !!error && /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Error2, {
    className: "input__error"
  }, error));
};




/***/ }),

/***/ 60049:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "f": function() { return /* binding */ ModalBody; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(91987);
/* harmony import */ var _BaseProps_index_es_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(25989);
/* harmony import */ var _emotion_styled__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(21483);




var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const Wrapper = _emotion_styled__WEBPACK_IMPORTED_MODULE_1__["default"].div(`
  flex: 1 1 auto;
  padding: 0.5rem 2rem;
  position: relative;
`, _BaseProps_index_es_js__WEBPACK_IMPORTED_MODULE_2__/* .CommonStyles */ .F);
const ModalBody = (_a) => {
  var _b = _a, {
    children
  } = _b, props = __objRest(_b, [
    "children"
  ]);
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Wrapper, __spreadValues({}, props), children);
};




/***/ }),

/***/ 47873:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "x": function() { return /* binding */ ModalHeader; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(91987);
/* harmony import */ var _emotion_styled__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(21483);



const ModalHeader = ({
  children,
  className
}) => /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Wrapper, {
  className
}, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Title, null, children));
const Wrapper = _emotion_styled__WEBPACK_IMPORTED_MODULE_1__["default"].div`
  padding: 1rem;
  text-align: center;
`;
const Title = _emotion_styled__WEBPACK_IMPORTED_MODULE_1__["default"].h5`
  margin-bottom: 0;
  color: ${(p) => p.theme.colors.textTitle};
`;




/***/ }),

/***/ 59960:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "P": function() { return /* binding */ ConsultationServiceFee; }
/* harmony export */ });
/* harmony import */ var _i18n_es_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(40415);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(91987);
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(21483);
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(36727);
/* harmony import */ var _teko_teko_ecommerce__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(57732);
/* harmony import */ var _teko_ds_foundation__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(60049);






const StyledInput = (0,_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_1__["default"])(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_2__/* .LegacyInput */ .t)`
  border-radius: 4px;
  background-color: #ffffff;
  margin-bottom: 0.5em;
`;
const StyledModalBody = (0,_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_1__["default"])(_teko_ds_foundation__WEBPACK_IMPORTED_MODULE_3__/* .ModalBody */ .f)`
  padding: 0;
`;
const StyledNotiText = _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_1__["default"].div`
  color: #82869e;
  font-size: 0.8125rem;
`;
const Row = _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_1__["default"].div(({ mb }) => `
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: ${mb || 0};
  `);
const StyledText = _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_1__["default"].span(({ color }) => `
  font-size: 0.8125rem;
  line-height: 1.5rem;
  font-weight: 500;
  color: ${color || "#434657"}`);
const defaultWarningText = (maxConsultationServiceFee, sellingPrice) => {
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(StyledNotiText, null, (0,_i18n_es_js__WEBPACK_IMPORTED_MODULE_4__.t)("\u0110\u01B0\u1EE3c ph\xE9p n\xE2ng gi\xE1 b\xE1n t\u1ED1i \u0111a"), " ", (0,_teko_teko_ecommerce__WEBPACK_IMPORTED_MODULE_5__/* .formatCurrency */ .x)(maxConsultationServiceFee + sellingPrice));
};
const getStyledCurrency = (amount) => {
  const formattedCurrency = (0,_teko_teko_ecommerce__WEBPACK_IMPORTED_MODULE_5__/* .formatCurrency */ .x)(amount);
  return amount >= 0 ? /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(StyledText, {
    color: "#2BB956"
  }, `+${formattedCurrency}`) : /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(StyledText, {
    color: "#E6983A"
  }, `${formattedCurrency}`);
};
const ConsultationServiceFee = ({
  maxConsultationServiceFee,
  sellingPrice,
  isShow = true,
  onChangePrice,
  defaultExpectedPrice
}) => {
  const initialWarningText = (0,_i18n_es_js__WEBPACK_IMPORTED_MODULE_4__.t)("Gi\xE1 mu\u1ED1n b\xE1n kh\xF4ng \u0111\u01B0\u1EE3c v\u01B0\u1EE3t qu\xE1 {{var0}}", {
    var0: (0,_teko_teko_ecommerce__WEBPACK_IMPORTED_MODULE_5__/* .formatCurrency */ .x)(maxConsultationServiceFee + sellingPrice)
  });
  const [showWarning, setShowWarning] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(false);
  const [changeAmount, setChangeAmount] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(0);
  const [warningText, setWarningText] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(initialWarningText);
  const handlePriceChange = (e) => {
    const expectedPrice2 = parseFloat(e.target.value);
    if (!!expectedPrice2 && expectedPrice2 < sellingPrice) {
      setShowWarning(true);
      setWarningText((0,_i18n_es_js__WEBPACK_IMPORTED_MODULE_4__.t)("Gi\xE1 mu\u1ED1n b\xE1n kh\xF4ng \u0111\u01B0\u1EE3c nh\u1ECF h\u01A1n gi\xE1 s\u1EA3n ph\u1EA9m"));
    } else if (!!expectedPrice2 && expectedPrice2 <= maxConsultationServiceFee + sellingPrice || !expectedPrice2) {
      setShowWarning(false);
    } else if (expectedPrice2 > maxConsultationServiceFee + sellingPrice) {
      setShowWarning(true);
      setWarningText(initialWarningText);
    }
    setExpectedPrice(expectedPrice2);
    setChangeAmount(expectedPrice2 - sellingPrice);
    if (onChangePrice)
      onChangePrice(e);
  };
  const [expectedPrice, setExpectedPrice] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(defaultExpectedPrice);
  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(() => {
    setExpectedPrice(defaultExpectedPrice);
    setChangeAmount(defaultExpectedPrice - sellingPrice);
  }, [sellingPrice, defaultExpectedPrice]);
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(react__WEBPACK_IMPORTED_MODULE_0__.Fragment, null, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(StyledModalBody, null, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Row, {
    mb: "0.5rem"
  }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(StyledText, null, (0,_i18n_es_js__WEBPACK_IMPORTED_MODULE_4__.t)("Gi\xE1 s\u1EA3n ph\u1EA9m")), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(StyledText, null, (0,_teko_teko_ecommerce__WEBPACK_IMPORTED_MODULE_5__/* .formatCurrency */ .x)(sellingPrice))), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Row, {
    mb: "0.25rem"
  }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(StyledText, null, (0,_i18n_es_js__WEBPACK_IMPORTED_MODULE_4__.t)("Gi\xE1 mu\u1ED1n b\xE1n"))), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(StyledInput, {
    placeholder: (0,_i18n_es_js__WEBPACK_IMPORTED_MODULE_4__.t)("Nh\u1EADp s\u1ED1 ti\u1EC1n"),
    onChange: handlePriceChange,
    value: expectedPrice,
    isFocused: isShow,
    inputType: "price",
    pattern: "\\d*",
    inputMode: "numeric",
    required: true,
    currency: (0,_i18n_es_js__WEBPACK_IMPORTED_MODULE_4__.t)("\u0111"),
    error: !!showWarning ? warningText : void 0,
    allowClear: false
  }), !showWarning && /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Row, {
    mb: "0.5rem"
  }, defaultWarningText(maxConsultationServiceFee || 0, sellingPrice || 0)), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Row, {
    mb: "0.5rem"
  }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(StyledText, null, (0,_i18n_es_js__WEBPACK_IMPORTED_MODULE_4__.t)("S\u1ED1 ti\u1EC1n ch\xEAnh:")), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(StyledText, null, getStyledCurrency(changeAmount)))));
};




/***/ }),

/***/ 15706:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/default/desktop/cart",
      function () {
        return __webpack_require__(97949);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 97949:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ desktop_cart; }
});

// EXTERNAL MODULE: ../../.yarn/cache/react-npm-18.2.0-1eae08fee2-88e38092da.zip/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(61261);
// EXTERNAL MODULE: ./i18n.ts
var i18n = __webpack_require__(34655);
// EXTERNAL MODULE: ../../.yarn/cache/react-npm-18.2.0-1eae08fee2-88e38092da.zip/node_modules/react/index.js
var react = __webpack_require__(91987);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@emotion-styled-virtual-dae21f56e7/0/cache/@emotion-styled-npm-11.3.0-a31c55914d-5e5c1e89d2.zip/node_modules/@emotion/styled/dist/emotion-styled.browser.esm.js + 2 modules
var emotion_styled_browser_esm = __webpack_require__(21483);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-foundation-virtual-250bf57412/1/packages/ds-foundation/dist/components/Modal/ModalHeader.es.js
var ModalHeader_es = __webpack_require__(47873);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-foundation-virtual-250bf57412/1/packages/ds-foundation/dist/components/Modal/Modal.es.js + 1 modules
var Modal_es = __webpack_require__(48441);
// EXTERNAL MODULE: ./modules/cart/desktop/Cart.tsx + 6 modules
var Cart = __webpack_require__(4117);
// EXTERNAL MODULE: ./modules/cart/CartContextV2.tsx
var CartContextV2 = __webpack_require__(34090);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ui-cart-virtual-6a37caca01/1/packages/ui-cart/dist/common/ChangePrice/ChangePrice.es.js
var ChangePrice_es = __webpack_require__(59960);
;// CONCATENATED MODULE: ./tenants/_template/desktop/cart.tsx
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    const data = _taggedTemplateLiteral([
        "\n  text-align: left;\n  padding: 0;\n  margin-bottom: 1em;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}







const StyledModalHeader = (0,emotion_styled_browser_esm["default"])(ModalHeader_es/* ModalHeader */.x)(_templateObject());
const CartPage = ()=>{
    const { cart , onChangeItemPrice  } = (0,CartContextV2/* useCartV2 */.T)();
    const { 0: priceEditorData , 1: setPriceEditorData  } = (0,react.useState)({
        id: "",
        price: 0,
        editedPrice: "",
        maxConsultationServiceFee: 0,
        defaultExpectedPrice: 0
    });
    const { 0: showPriceEditor , 1: setShowPriceEditor  } = (0,react.useState)(false);
    const priceEditorError = !priceEditorData.editedPrice || priceEditorData.price > Number(priceEditorData.editedPrice) || Number(priceEditorData.editedPrice) > priceEditorData.price + Number(priceEditorData.maxConsultationServiceFee);
    const doEditPrice = (id, price, defaultExpectedPrice, maxConsultationServiceFee)=>{
        setShowPriceEditor(true);
        setPriceEditorData({
            id,
            price,
            maxConsultationServiceFee,
            editedPrice: defaultExpectedPrice.toString(),
            defaultExpectedPrice
        });
    };
    const doChangePrice = (event)=>{
        setPriceEditorData((prev)=>_objectSpreadProps(_objectSpread({}, prev), {
                editedPrice: event.target.value
            }));
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Cart/* Cart */.AP, {
                cartData: cart,
                onEditPrice: doEditPrice
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Modal_es/* Modal */.u, {
                width: "400px",
                visible: showPriceEditor,
                onClose: ()=>{
                    setShowPriceEditor(false);
                },
                showCloseIcon: false,
                contentStyle: {
                    padding: "2rem"
                },
                onCancel: ()=>{
                    setShowPriceEditor(false);
                },
                onOk: async ()=>{
                    setShowPriceEditor(false);
                    await onChangeItemPrice(priceEditorData);
                },
                okButtonProps: {
                    disabled: priceEditorError
                },
                okText: "X\xe1c nhận",
                cancelText: "Hủy",
                alignFooter: "right",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledModalHeader, {
                        children: (0,i18n.t)("Thay đổi gi\xe1 sản phẩm")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ChangePrice_es/* ConsultationServiceFee */.P, {
                        isShow: showPriceEditor,
                        sellingPrice: priceEditorData.price,
                        maxConsultationServiceFee: priceEditorData.maxConsultationServiceFee,
                        onChangePrice: doChangePrice,
                        defaultExpectedPrice: priceEditorData.defaultExpectedPrice
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var cart = (CartPage);

;// CONCATENATED MODULE: ./pages/default/desktop/cart.tsx
// AUTO GENERATED FILE. DO NOT EDIT.

/* harmony default export */ var desktop_cart = (cart);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [9690,1668,1811,1026,1271,828,9781,468,3290,9279,4975,4239,3680,2914,3712,9774,2888,179], function() { return __webpack_exec__(15706); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);